export type SidebarMode = 'full' | 'compact' | 'icon-only';

const ALL_MODES: SidebarMode[] = ['full', 'compact', 'icon-only'];

export const SIDEBAR_WIDTHS: Record<SidebarMode, { className: string; offset: string }> = {
  full: { className: 'lg:w-64', offset: '256px' },
  compact: { className: 'lg:w-[88px]', offset: '88px' },
  'icon-only': { className: 'lg:w-16', offset: '64px' },
};

export const getAvailableSidebarModes = (): SidebarMode[] => {
  const envModes = import.meta.env.VITE_SIDEBAR_MODES as string | undefined;
  if (!envModes) return ALL_MODES;

  const modes = envModes
    .split(',')
    .map((m) => m.trim() as SidebarMode)
    .filter((m) => ALL_MODES.includes(m));

  return modes.length > 0 ? modes : ALL_MODES;
};

export const getDefaultSidebarMode = (): SidebarMode => getAvailableSidebarModes()[0];

export const getNextSidebarMode = (current: SidebarMode): SidebarMode => {
  const modes = getAvailableSidebarModes();
  if (modes.length <= 1) return current;
  const currentIndex = modes.indexOf(current);
  return modes[(currentIndex + 1) % modes.length];
};

export type SidebarStyle = 'dark' | 'light';

export const getSidebarStyle = (): SidebarStyle => {
  const style = import.meta.env.VITE_SIDEBAR_STYLE as string;
  return style === 'light' ? 'light' : 'dark';
};

export const getSidebarBgColor = (): string | null => {
  const color = import.meta.env.VITE_SIDEBAR_BG_COLOR as string;
  return color && color.startsWith('#') ? color : null;
};

export const migrateSidebarState = (): SidebarMode | null => {
  const oldKey = localStorage.getItem('sidebarCollapsed');
  if (oldKey === null) return null;

  const migrated: SidebarMode = oldKey === 'true' ? 'icon-only' : 'full';
  localStorage.removeItem('sidebarCollapsed');
  localStorage.setItem('sidebarMode', migrated);
  return migrated;
};
